module.exports = __webpack_public_path__ + "img/square.914dfd3a.svg";